import { Link } from 'react-router-dom';
import { servicesData } from '@/mocks/home';

export default function ServicesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            全方位体育服务
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            从培训到赛事，从健身到场馆，云开体育为您提供一站式的专业体育服务体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {servicesData.map((service) => (
            <Link
              key={service.slug}
              to={`/category/${service.slug}`}
              className="group bg-background-50 rounded-xl p-6 transition-all hover:scale-[1.02] cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${service.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{service.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{service.description}</p>
              <div className="flex items-center gap-1 mt-4 text-primary-600 text-sm font-medium">
                <span>了解更多</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}